/** @format */

/**
 * a random value used to confirm that the microsoft auth response came from here
 */
export const HWB_AUTH_STATE_VALUE = "cxiyfadshflkjcsfyideys";

/**
 * @see https://learn.microsoft.com/en-us/graph/auth-v2-user?view=graph-rest-1.0&tabs=http#parameters
 * @see https://login.microsoftonline.com/b4029029-8a77-4e5a-a874-318a8ff3f073/v2.0/.well-known/openid-configuration
 */
export const getHwbAuthLink = (): string => {
  const queryStringParams = {
    client_id: process.env.REACT_APP_HWB_OAUTH_KEY ?? "",
    redirect_uri: `${window.location.origin}/en/auth/hwblogin`,
    response_type: "code",
    response_mode: "query",
    state: HWB_AUTH_STATE_VALUE,
    scope: ["openid", "profile", "email"].join(" "),
  };
  const queryString = new URLSearchParams(queryStringParams).toString();

  return `https://login.microsoftonline.com/${process.env.REACT_APP_HWB_OAUTH_TENANT_ID}/oauth2/v2.0/authorize?${queryString}`;
};
